import React from 'react'
import { View, TouchableHighlight } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import Moment from 'moment'

//Services
import Analytics from 'APP/Services/Analytics'
import I18n from 'APP/I18n'
import { getPractitionerName, getEmptyPractitioner, getImage } from 'APP/Lib/PractitionerHelpers'

// Styling
import Styles from './style'
import styled, { useTheme } from 'styled-components/native'
import IcCarePlan from 'APP/Images/ic_care_plan.svg'
import Typography from 'APP/Converse/Typography'

const CarePlanReason = styled(Typography).attrs({
  numberOfLines: 1,
  ellipsizeMode: 'tail',
  variant: 'h4',
})``

const CarePlanFrom = styled(Typography).attrs({
  variant: 'bodyNormal',
})`
  margin-top: 4px;
`

const CarePlanTimestamp = styled(Typography).attrs({
  variant: 'caption',
})`
  color: ${({ theme }) => theme.colors.dim};
  padding-bottom: 6px;
`

const CarePlanListItem = ({
  carePlan,
  episode,
  disabled,
  showDivider = true,
  style,
  title,
  description,
  onPressHandler,
}) => {
  const theme = useTheme()
  const navigation = useNavigation()
  // If carePlan is provided, use its properties, otherwise use the provided title and description
  const { practitioner, reason, endTime } = carePlan || {}
  const emptyPractitioner = getEmptyPractitioner(I18n.baseLocale, 'carePlanList')
  const practitionerName = getPractitionerName(practitioner) || emptyPractitioner?.name

  const onCarePlanClicked = (...args) => {
    // If a custom onPress handler is provided, use it
    if (onPressHandler) {
      onPressHandler(...args)
      return
    }

    // Otherwise use the default behavior
    Analytics.trackEvent('button_click', {
      button_value: 'CarePlanList.carePlan',
    })
    navigation.navigate('carePlan', { carePlan, channelId: episode?.channelId })
  }
  const styles = practitioner ? Styles.avatar : Styles.diaLogo
  const dividerStyle = showDivider
    ? { borderBottomWidth: 1, borderBottomColor: theme.colors.elementsBorder }
    : {}

  return (
    <TouchableHighlight
      style={[Styles.clickableContainer, style]}
      underlayColor={theme.colors.listFocus}
      disabled={disabled}
      onPress={onCarePlanClicked}
    >
      <View style={[Styles.carePlanContainer, dividerStyle]}>
        <View style={Styles.carePlanLeft}>
          <IcCarePlan height={20} width={20} accentFillLine={theme.colors.accent} />
          <View style={Styles.carePlanInfo}>
            <CarePlanReason>{title || reason}</CarePlanReason>
            <CarePlanFrom>
              {description ||
                I18n.t('CarePlanList.from', {
                  practitionerName,
                  interpolation: { escapeValue: false },
                })}
            </CarePlanFrom>
          </View>
        </View>
        {!carePlan ? null : (
          <View style={Styles.carePlanMetadata}>
            <CarePlanTimestamp>{Moment.utc(endTime).local().fromNow()}</CarePlanTimestamp>
            {getImage(practitioner, styles)}
          </View>
        )}
      </View>
    </TouchableHighlight>
  )
}

export default CarePlanListItem
